import React from 'react';
import { Spinner } from './ui/spinner';
import { PartyPopper } from 'lucide-react';
import congresImgUrl from '@/assets/images/congres.png';
import { Button } from './ui/button';

const CongresOverlay = ({ isLoading, text, onNavigate, buttonText }: { isLoading: boolean, text: string, onNavigate?: () => void, buttonText?: string }) => {
    if (!isLoading) return <></>;

    return (
        <>
            <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="animate-fade-in flex flex-col items-center justify-center bg-green-50 rounded-4xl w-100 h-100 gap-4 [@media(max-height:500px)]:!w-[300px] [@media(max-height:500px)]:!h-[300px] [@media(max-height:500px)]:!gap-2 [@media(max-height:500px)]:!rounded-3xl">
                    {/* <PartyPopper className="text-violet-800 size-50"/> */}
                    <img className='w-2/3 h-2/3' src={congresImgUrl}></img>
                    <p className="text-violet-800 text-2xl [@media(max-height:500px)]:!text-lg">{text}</p>
                    {onNavigate && (
                        <Button variant="default" className="bg-primary mt-4 [@media(max-height:500px)]:!mt-2 [@media(max-height:500px)]:!h-8 [@media(max-height:500px)]:!text-sm" onClick={onNavigate}>
                            {buttonText}
                        </Button>
                    )}
                </div>
            </div>

            <div className="fixed inset-0 bg-black opacity-60 flex items-center justify-center z-40">
            </div>
        </>
    );
};

export default CongresOverlay;